const STORAGE_KEY = 'gamemvm:favorites';

export const getFavorites = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    console.warn('localStorage unavailable', err);
    return [];
  }
};

export const setFavorites = favorites => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  } catch (err) {
    console.warn('failed to persist favorites', err);
  }
};

export const toggleFavorite = slug => {
  const favorites = new Set(getFavorites());
  if (favorites.has(slug)) {
    favorites.delete(slug);
  } else {
    favorites.add(slug);
  }
  const list = Array.from(favorites);
  setFavorites(list);
  return list;
};

export const isFavorite = slug => getFavorites().includes(slug);

